export default (length) => ({
  index: 3,

  next() {
    this.index = (this.index + 1) % length;
  },

  prev() {
    this.index = (this.index - 1 + length) % length;
  },

  scrollTo(index) {
    const direction = index < this.index ? -1 : 1;
    const i = setInterval(() => {
      this.index += direction;
      if (this.index === index) {
        clearInterval(i);
      }
    }, 200);
  },

  getPos(index) {
    const elemClass = 'topped-references__list__item';
    const distance = Math.abs((index - this.index + length) % length);
    const shortestDistance = Math.min(distance, length - distance);
    const direction = distance <= length / 2 ? 'right' : 'left';
    if (shortestDistance <= 3 && shortestDistance !== 0) {
      return this.classBuilder(elemClass, [
        shortestDistance.toString(),
        direction,
      ]);
    }
    return '';
  },

  classBuilder(elemClass, modifiers) {
    let ret = '';
    modifiers.forEach((modifier) => {
      if (ret != '') {
        ret += ' ';
      }
      ret += elemClass + '--' + modifier;
    });
    return ret;
  },

  init() {},
});
